import unescapedText from 'I18n/utils/unescapedText';

// TEAM_KEYS
export const COPILOT_SANDBOX_TEAM_KEY = 'copilot-sandbox-ui';
export const TEAM_KEYS = [COPILOT_SANDBOX_TEAM_KEY];
// ACTION_KEYS
export const COPILOT_SANDBOX_FOLLOWUP_ACTIONS = 'bullet-points-action';
export const ACTION_KEYS = [COPILOT_SANDBOX_FOLLOWUP_ACTIONS];
// Registry
export const getCopilotFollowUpPrompt = (teamKey, actionKey) => {
  const registry = {
    [COPILOT_SANDBOX_TEAM_KEY]: {
      [COPILOT_SANDBOX_FOLLOWUP_ACTIONS]: unescapedText('copilotToolkit.streamingMessage.followUp.copilotSandbox.bulletPointsAction')
    }
  };

  // Check if team exists in registry
  if (!registry[teamKey]) {
    console.warn(`Team key "${teamKey}" not found in CopilotFollowUpPromptRegistry`);
    return '';
  }

  // Check if action exists for the team
  if (!registry[teamKey][actionKey]) {
    console.warn(`Action key "${actionKey}" not found for team "${teamKey}" in CopilotFollowUpPromptRegistry`);
    return '';
  }
  return registry[teamKey][actionKey];
};